import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style/modern-mobile-interactions.js';
import './style/android-navbar-utils.js';
import './assets/js/custom.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './utils/sentryInit';

// Globally silence debug console output (console.log/info/debug) across the
// whole app — including the reservation API and all third-party scripts.
// console.warn and console.error are kept so genuine problems and Sentry
// error tracking still work.
const noop = () => {};
console.log = noop;
console.info = noop;
console.debug = noop;

// Initialize Sentry error tracking (only runs in production by default)
initSentry();

// Suppress external script errors (e.g., BoosterScript, third-party scripts)
// These errors should not show on the frontend
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || e.message === 'Script error') {
    e.preventDefault();
    return;
  }
});
window.addEventListener('unhandledrejection', (e) => {
  // Suppress unhandled promise rejections from external scripts
  if (e.reason?.message === 'Script error.' || e.reason?.message === 'Script error') {
    e.preventDefault();
  }
});

// Render React app immediately - theme loading handled by components
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
